import { render, staticRenderFns } from "./VinculoDistribuidora.vue?vue&type=template&id=517c806b"
import script from "./VinculoDistribuidora.vue?vue&type=script&lang=js"
export * from "./VinculoDistribuidora.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports